// extracted by mini-css-extract-plugin
module.exports = {"headerText":"styles__headerText___K-a9V","secondaryText":"styles__secondaryText___eFZYm","star":"styles__star___1wuVk","starred":"styles__starred___lcqtt"};